import { DataReaderService } from './service/data-reader.service';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AssistenzaComponent } from './assistenza/assistenza.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AssistenzaComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule
    
  ],
  providers: [DataReaderService],
  bootstrap: [AppComponent]
})
export class AppModule { }
